module.exports = __webpack_public_path__ + "img/closed-toe-shoes-no.829c68c0.svg";